import { EmployeeDictionaryType } from "../../../models/employeeHub";
import { useEmployeeDictionary } from "../../../hooks/queries/useEmployeeDictionary";

export function useEmployeeFilterDictionaries() {
    const costCenters = useEmployeeDictionary(EmployeeDictionaryType.CostCenter);
    const projects = useEmployeeDictionary(EmployeeDictionaryType.Project);
    const workSchedules = useEmployeeDictionary(EmployeeDictionaryType.WorkSchedule);
    const positions = useEmployeeDictionary(EmployeeDictionaryType.Position);
    const contractTypes = useEmployeeDictionary(EmployeeDictionaryType.ContractType);

    return { costCenters, projects, workSchedules, positions, contractTypes };
}
